import * as actionTypes from '../constants/general'
import {apiCall} from '../../service/apiCall'
import { URL, USER,PASS } from '../../service/base_url'
import {get} from 'lodash'
export const modalToggle=(obj)=>async dispatch=>{
    dispatch({
        type:actionTypes.MODAL_SHOW,
        payload:obj
    })
}

export const modalToggleReset=(obj)=>async dispatch=>{
    dispatch({
        type: actionTypes.MODAL_RESET,
        payload: obj
      });
}

export const setLoading =(payload)=>dispatch=>{
    dispatch({
        type:actionTypes.SET_LOADING,
        payload
    })
}
export const setLoadingBeranda =(payload)=>dispatch=>{
    dispatch({
        type:actionTypes.SET_LOADING_BERANDA,
        payload
    })
}
export const setLoadingFilter =(payload)=>dispatch=>{
    dispatch({
        type:actionTypes.SET_LOADING_FILTER,
        payload
    })
}
export const setLoadingComment =(payload)=>dispatch=>{
    dispatch({
        type:actionTypes.SET_LOADING_COMMENT,
        payload
    })
}
export const setLoadingTable =(payload)=>dispatch=>{
    // alert('hello')
    dispatch({
        type:actionTypes.SET_LOADING_TABLE,
        payload
    })
}

export const setError =(payload)=>dispatch=>{
    dispatch({
        type:actionTypes.SET_ERROR,
        payload
    })
}
